export default __webpack_public_path__ + "static/media/filgreen3.10d08c93.png";